import { Code } from "@radix-ui/themes"
import clsx from "clsx"
import { Check, Copy } from "lucide-react"
import { useState } from "react"

interface CopyableCodeProps {
  code: string
  className?: string
}

export default function CopyableCode({ code, className }: CopyableCodeProps) {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    void navigator.clipboard.writeText(code)
    setCopied(true)
    setTimeout(() => setCopied(false), 1200)
  }

  return (
    <div className="relative cursor-pointer" onClick={handleCopy}>
      <Code size="3" className={clsx("block pr-12", className)}>
        {code}
      </Code>

      <button
        onClick={handleCopy}
        className="pointer-events-none absolute top-[0px] right-[1px] p-2 text-gray-600 transition-colors hover:text-gray-900"
      >
        {copied ? <Check size={14} /> : <Copy size={14} />}
      </button>
    </div>
  )
}
